// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q8dKtHJzHkKRKd {
  position: relative;
  max-width: 900px;
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-400, 32px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profilePageContainer": `q8dKtHJzHkKRKd`
};
export default ___CSS_LOADER_EXPORT___;
